<template>
  <base-content :data="data"
    :index="index">
      <template #card-header>
        <partial-title
          :title="title"
          :link="link"
          :lineClamp="3"
        />
      </template>

      <template #card-body>
        <ul>
          <li class="t-sm">
              <i class="fa fa-quote-right t-secondary t-sm pr-2 t-xs" :class="{ invisible: !data.estimated_citation_count }" />
              <template v-if="data.estimated_citation_count">
                <span class="t-600">{{ data.estimated_citation_count }}</span> {{ 'citation' | pluralize(data.estimated_citation_count) }}
              </template>
          </li>
          <matches v-if="!isEmpty(matches)" :matches="matches" />
        </ul>
      </template>

      <template #card-footer>
        <partial-owners v-if="!isEmpty(authors)"
          :lineClamp="1"
          :owners="authors"
          :totalOwners="data.authors_count"
          :maxItems="maxAuthors"
          :isSlicedInMiddle="data.top_authors.length > maxAuthors ? true : false"
          :renderWithLinkTo="false">
        </partial-owners>

        <li v-if="data.publication_date || journal" class="row-content row-content_small">
          <span class="row-content--side"><span v-if="data.publication_date">{{ data.publication_date | formatDate('YYYY') }}</span></span>
          <span v-if="journal" v-line-clamp:20="2" v-html="journal.name" class="row-content--main"></span>
        </li>
      </template>
      <template #card-actions>
        <slot name="actions"></slot>
      </template>
  </base-content>
</template>

<script>
import processing from '@/mixins/search/results/publication'

import BaseContent from '@/components/search/results/BaseContent'
import Matches from '@/components/search/results/partials/Matches'
import PartialTitle from '@/components/search/results/partials/Title'
import PartialOwners from '@/components/search/results/partials/Owners'

export default {
  name: 'publicationResultBlock',
  mixins: [processing],
  components: {
    Matches,
    PartialTitle,
    PartialOwners,
    BaseContent
  },
  data () {
    return {
      maxAuthors: 2
    }
  }
}
</script>
